import { motion } from "framer-motion";

export default function StoryBlock() {
  return (
    <section className="py-28 bg-white">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 px-6 items-start md:items-center">

        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl font-serif mb-6">
            Nacimos de una necesidad real
          </h2>

          <p className="text-gray-700 leading-relaxed">
            Encontrar profesionales confiables se volvió complejo en un mundo
            saturado de opciones sin garantías.
            <br /><br />
            Decidimos crear un puente entre personas que buscan tranquilidad
            y profesionales que merecen respaldo y visibilidad.
          </p>
        </motion.div>

        <motion.img
          src="/img/quienesSomos/story.jpeg"
          alt="Trabajo profesional"
          className="w-full h-[420px] object-cover rounded-xl"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        />
      </div>
    </section>
  );
}

